module.exports = "https://static-production.npmjs.com/34110fd7686e2c90a487ca98e7336e99.png";